module.exports = __webpack_public_path__ + "img/4.0c00e0ff.jpg";